import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { _ } from "../utils/i18n";
import { handleCheckboxes } from "../utils/helpers";
import { GlobalDispatchContext } from "../context/global-context-provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import Separator from "./separator";

const BrandFilterWrapper = styled.div`
  background-color: var(--color-body);
  margin: 1rem 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  h2 {
    font-size: clamp(1.2rem, 2.5vw, 1.5rem);
  }
  & label {
    display: block;
    position: relative;
    padding-left: 1.6rem;
    margin-bottom: 15px;
    cursor: pointer;
  }
  & input[type="checkbox"] {
    visibility: hidden;
  }
  & span {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: var(--color-white);
  }
  & input:checked ~ span {
    background-color: var(--color-primary);
  }
  & span:after {
    content: "";
    position: absolute;
    display: none;
  }
  & input:checked ~ span:after {
    display: block;
  }
  & span:after {
    left: 7px;
    bottom: 5px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const ShowMoreButton = styled.button`
  width: 100%;
  height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  text-align: left;
  display: flex;
  align-items: center;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  padding-left: 5px;
`;

const ProductBrandsFilter = ({ brands, allProducts }) => {
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [showAllBrands, setShowAllBrands] = useState(false);
  const dispatch = useContext(GlobalDispatchContext);
  const [privateOrBusiness, setPrivateOrBusiness] = useState(
    typeof window !== "undefined" && localStorage.getItem("private-business")
  );

  useEffect(() => {
    let filterByBrand = [];
    allProducts.forEach(
      (product) =>
        product.productBrands?.nodes.length > 0 &&
        product.productBrands.nodes.find((item) => {
          selectedBrand.includes(item.slug) && filterByBrand.push(product);
        })
    );

    const newProducts =
      selectedBrand.length > 0 ? [...filterByBrand] : allProducts;

    privateOrBusiness === "private"
      ? dispatch({
          type: "UPDATE_PRODUCTS_PRIVATE",
          value: newProducts,
        })
      : dispatch({
          type: "UPDATE_PRODUCTS_BUSINESS",
          value: newProducts,
        });

    const productTitles = allProducts.map((product) => product.name);
    setFilteredBrands(
      structuredClone(brands.nodes).filter((brand) => {
        if (brand?.products) {
          brand.products = brand.products.filter((product) =>
            productTitles.includes(product.name)
          );

          return brand.products.length > 0;
        }
        return false;
      })
    );
  }, [allProducts, selectedBrand]);

  const checkPrivateOrBusiness = () => {
    setPrivateOrBusiness(localStorage.getItem("private-business"));
  };

  useEffect(() => {
    window.addEventListener("storage", checkPrivateOrBusiness);
    return () => removeEventListener("storage", checkPrivateOrBusiness);
  }, []);

  const displayedBrands = showAllBrands
    ? filteredBrands
    : filteredBrands.slice(0, 8);

  return (
    <BrandFilterWrapper>
      <h2>{_("Merke")}</h2>
      <div>
        {displayedBrands.map((brand) => (
          <label key={brand.id}>
            {brand.name}
            <input
              type="checkbox"
              value={brand.slug}
              name={brand.slug}
              onChange={(e) => {
                handleCheckboxes(e, e.target.value, setSelectedBrand);
              }}
            />
            <span />
          </label>
        ))}
        {!showAllBrands && filteredBrands.length > 8 && (
          <ShowMoreButton onClick={() => setShowAllBrands(true)}>
            {_("Vis mer")}
            <StyledIcon icon={faAngleDown} />
          </ShowMoreButton>
        )}
      </div>
      <Separator isWide $backgroundColor="grey" />
    </BrandFilterWrapper>
  );
};

ProductBrandsFilter.propTypes = {
  brands: PropTypes.object,
  allProducts: PropTypes.arrayOf(PropTypes.object),
};

export default ProductBrandsFilter;
